import { useEffect, useState } from 'react';

import { useEditProfileDataContext } from '../../../../context/account/editProfile.provider';
import { useAuthDataContext } from '../../../../context/auth/auth.provider';
import { dataLayerPush } from '../../../../helpers/dataLayerPush';
import useForm from '../../../../helpers/useForm';
import EditProfileValidation from './EditProfile.validations';

const useEditProfile = () => {
  const [open, setOpen] = useState(false);
  const { user, setUserData } = useAuthDataContext();
  const { loading, submitSuccess, updateProfile } = useEditProfileDataContext();
  const [plusPhone, setPlusPhone] = useState(false);
  const [defaultValues] = useState({
    email: user.email,
    phone_number: user?.phone?.split('-').join('') ?? null,
    emergency_phone: user.emergency_phone,
  });

  useEffect(() => {
    dataLayerPush('Cuenta_editar_datos_perfil', user?.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (submitSuccess.update_profile) {
      setUserData(submitSuccess.update_profile);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitSuccess]);

  const onSubmit = () => {
    updateProfile(values);
    onClose();
  };

  const { values, errors, handleChange, handleSubmit } = useForm(
    onSubmit,
    EditProfileValidation,
    defaultValues
  );

  const onClose = () => {
    setOpen(false);
  };

  const onOpen = () => {
    setOpen(true);
  };

  return {
    loading,
    open,
    onClose,
    handleSubmit,
    errors,
    handleChange,
    values,
    user,
    plusPhone,
    setPlusPhone,
    onOpen,
  };
};

export default useEditProfile;
